/* src/app/views/template/components/templates/print/print-templates.component.scss */
/*# sourceMappingURL=print-templates.component.css.map */
